import { render, staticRenderFns } from "./HealthWebUnavailable.vue?vue&type=template&id=21efbe1a&scoped=true&"
import script from "./HealthWebUnavailable.vue?vue&type=script&lang=ts&"
export * from "./HealthWebUnavailable.vue?vue&type=script&lang=ts&"
import style0 from "./HealthWebUnavailable.vue?vue&type=style&index=0&id=21efbe1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efbe1a",
  null
  
)

export default component.exports